'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * FeedbackState
 *
 * Holds the internal values for each of the available states in the FeedbackManager,
 * - FeedbackState.Ready
 * - FeedbackState.Busy
 * - FeedbackState.Fail
 */
var FeedbackState = exports.FeedbackState = {
  Ready: 'ready',
  Busy: 'busy',
  Fail: 'fail'
};

/**
 * FeedbackManager
 *
 * The FeedbackManager applies css classes and messaging to one or more target elements
 * in your component, identified by the presence of te 'feedback' css class.
 *
 * ie. <button class="feedback" ng-click="doSomething()">
 *
 * When constructing the FeedbackManager, you provide the root element of the component,
 * and a set of labels to apply on the button according to each of the following named
 * states:
 *
 *   {
 *     ready: 'Normal button label used when idle',
 *     busy: 'Processing...',
 *     fail: 'Something went wrong...'
 *   }
 *
 * Once initialized, call the following methods to switch states:
 *
 *   mgr.start()  // Start an operation,  eg. switches state from ready to busy
 *   mgr.finish() // Finish an operation, eg. switches state from busy to ready
 *   mgr.fail()   // Fail an operation,   eg. switches state from busy to fail
 */

var FeedbackManager = exports.FeedbackManager = function () {
  function FeedbackManager(element) {
    var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ready: 'Go',
      busy: 'Working...',
      fail: 'Something went wrong.'
    };

    _classCallCheck(this, FeedbackManager);

    this.elements = [];

    this.labels = labels;
    this.elements = this.getElementsList(element, 'feedback');
    this.icons = this.getElementsList(element, 'icon');
    this._state = FeedbackState.Ready;
    this.addClass(this.allElements, FeedbackState.Ready);
  }

  _createClass(FeedbackManager, [{
    key: 'getElementsList',
    value: function getElementsList(element, className) {
      var elements = element.getElementsByClassName(className),
          found = [];
      if (elements) for (var i = 0; i < elements.length; i++) {
        found.push(elements[i]);
      }return found;
    }
  }, {
    key: 'ready',
    value: function ready() {
      this.resetTo(FeedbackState.Ready);
    }
  }, {
    key: 'start',
    value: function start() {
      this.resetTo(FeedbackState.Busy);
      this.disable();
      clearTimeout(this.timeout);
    }
  }, {
    key: 'finish',
    value: function finish() {
      this.resetTo(FeedbackState.Ready);
    }
  }, {
    key: 'fail',
    value: function fail() {
      var _this = this;

      this.resetTo(FeedbackState.Fail);
      this.timeout = setTimeout(function () {
        return _this.ready();
      }, 5000);
    }
  }, {
    key: 'failWithMessage',
    value: function failWithMessage(message) {
      this.labels.fail = message;
      this.fail();
    }
  }, {
    key: 'removeKnownClasses',
    value: function removeKnownClasses() {
      var _this2 = this;

      [FeedbackState.Ready, FeedbackState.Busy, FeedbackState.Fail].forEach(function (c) {
        return _this2.removeClass(_this2.allElements, c);
      });
    }
  }, {
    key: 'resetTo',
    value: function resetTo(state) {
      this._state = state;
      this.removeKnownClasses();
      this.enable();
      this.addClass(this.allElements, state);
      this.setLabel(state);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.elements.forEach(function (e) {
        return e.setAttribute('disabled', 'true');
      });
    }
  }, {
    key: 'enable',
    value: function enable() {
      this.elements.forEach(function (e) {
        return e.removeAttribute('disabled');
      });
    }
  }, {
    key: 'setLabel',
    value: function setLabel(state) {
      var _this3 = this;

      this.elements.forEach(function (e) {
        if (e.tagName.toUpperCase() === 'INPUT') e.setAttribute('value', _this3.labels[state]);else e.innerText = _this3.labels[state];
      });
    }
  }, {
    key: 'addClass',
    value: function addClass(elements, name) {
      elements.forEach(function (e) {
        return e.classList.add(name);
      });
    }
  }, {
    key: 'removeClass',
    value: function removeClass(elements, name) {
      elements.forEach(function (e) {
        return e.classList.remove(name);
      });
    }
  }, {
    key: 'allElements',
    get: function get() {
      return this.elements.concat(this.icons);
    }
  }, {
    key: 'state',
    get: function get() {
      return this._state;
    }
  }]);

  return FeedbackManager;
}();